/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GUFEvent } from "./GUFEvent";
import {
  GUFEventFromJSON,
  GUFEventFromJSONTyped,
  GUFEventToJSON,
  GUFEventToJSONTyped,
} from "./GUFEvent";

/**
 *
 * @export
 * @interface ApiGufEventsList200Response
 */
export interface ApiGufEventsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGufEventsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGufEventsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGufEventsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GUFEvent>}
   * @memberof ApiGufEventsList200Response
   */
  results: Array<GUFEvent>;
}

/**
 * Check if a given object implements the ApiGufEventsList200Response interface.
 */
export function instanceOfApiGufEventsList200Response(
  value: object
): value is ApiGufEventsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGufEventsList200ResponseFromJSON(json: any): ApiGufEventsList200Response {
  return ApiGufEventsList200ResponseFromJSONTyped(json, false);
}

export function ApiGufEventsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGufEventsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GUFEventFromJSON),
  };
}

export function ApiGufEventsList200ResponseToJSON(json: any): ApiGufEventsList200Response {
  return ApiGufEventsList200ResponseToJSONTyped(json, false);
}

export function ApiGufEventsList200ResponseToJSONTyped(
  value?: ApiGufEventsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GUFEventToJSON),
  };
}
